/* Schäferhome — Lupe auf dem Hauptbild der Produktseite.

   Warum nicht Dawns magnify.js: das arbeitet klickbasiert und legt eine
   Vollbild-Ebene über das Bild — damit wäre der Klick für die Lightbox
   belegt. Hier vergrößert reines Überfahren, der Klick bleibt frei.

   Nur für echte Zeigergeräte. Auf Touch gibt es kein "Überfahren"; dort
   führt die Berührung direkt in die Lightbox.

   Umgesetzt über transform-origin statt einer zweiten Bildebene: keine
   zusätzliche Anfrage, kein Nachladen, kein Flackern beim ersten Hover.
*/
(function () {
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var FACTOR = 2.2;

  function bind(box) {
    var img = box.querySelector('img');
    if (!img || box.dataset.shZoomBound) return;
    box.dataset.shZoomBound = '1';

    box.addEventListener('mouseenter', function () {
      img.style.transition = 'transform .18s ease-out';
      img.style.transform = 'scale(' + FACTOR + ')';
    });

    box.addEventListener('mousemove', function (e) {
      var r = box.getBoundingClientRect();
      // Nach dem ersten Zug ohne Übergang, sonst "schwimmt" das Bild dem Zeiger hinterher
      img.style.transition = 'none';
      img.style.transformOrigin =
        ((e.clientX - r.left) / r.width) * 100 + '% ' +
        ((e.clientY - r.top) / r.height) * 100 + '%';
    });

    box.addEventListener('mouseleave', function () {
      img.style.transition = 'transform .18s ease-out';
      img.style.transform = '';
      img.style.transformOrigin = 'center center';
    });
  }

  function scan() {
    document.querySelectorAll('[data-sh-zoom]').forEach(bind);
  }

  scan();
  // Nach Variantenwechsel tauscht Dawn die Galerie aus
  document.addEventListener('shopify:section:load', scan);
  document.addEventListener('variant:change', scan);
})();
